import './utils/chunk_retry'; // Global chunk load retry - must be first import
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import {ToastPortal} from '@idexcel-technologies-pvt-ltd/cync-los-common-components';
import 'react-toastify/dist/ReactToastify.css';
import '@idexcel-technologies-pvt-ltd/cync-los-common-components/dist/index.css';
import "./assets/css/default.css";
import ErrorBoundary from './components/error_boundary';
import { BrowserRouter as Router } from "react-router";

const root = ReactDOM.createRoot(document.getElementById('app'));

root.render(
    <>
        <ErrorBoundary>
            <Router>
                <App />
                <ToastPortal />
            </Router>
        </ErrorBoundary>
    </>
);